import { Component, Input, OnInit } from '@angular/core';
import { PageChangedEvent } from 'ngx-bootstrap/pagination';
import { EssentialService } from '../../services/essential.service';
import { DataSourceService } from '../../shared-components/data-source.service';
declare const $: any;

@Component({
  selector: 'app-html-data',
  templateUrl: './html-data.component.html',
  styleUrls: ['./html-data.component.css'],
})
export class DataHtmlComponent implements OnInit {
  @Input() public settings: any;
  @Input() public data: any;

  public APIData: any = [];
  public site: any;
  public columns = [];
  public displayedColumns: any[];
  public dataSource: any;
  public sort: any;
  public paginator: any;
  public totalItems = 0;
  public showItems = 0;
  public disblayedData: any[] = [];
  public maxSize = 5;
  public rotate = true;
  public testREs: any;
  constructor(
    private dataSourceService: DataSourceService,
    private essentialsService: EssentialService,
  ) { }

  public ngOnInit() {
    this.site = this.data.moduleService.site;
    this.settings.colList = this.settings.colList || [];
    if (this.settings.contentFrom === 1) {
      this.getManualData();
    } else if (this.settings.contentFrom === 2) {
      this.getDSData();
    }
    this.showItems = this.settings.itemsPerPage;
  }


  public getDataHtmlTemplate(data) {
    return this.setDataKeys(data, this.settings.HTML);
  }

  public setDataKeys(myJsonObject, HTML) {
    while (HTML.indexOf('${{') !== -1) {
      try {
        const start = HTML.indexOf('${{');
        const end = HTML.indexOf('}}', start) + 2;
        const key = HTML.substr(start + 3, end - 2 - (start + 3));
        const replace = HTML.substr(start, end - start);
        const value = myJsonObject[key];
        if (value != null) {
          HTML = HTML.replace(replace, value.toString());
        } else {
          HTML = HTML.replace(replace, ' ');
        }
      } catch (Exception) {
        break;
      }
    }
    return HTML;

  }
  //
  public getDSData() {
    let data: any;
    this.APIData = [];
    let url: string;
    data = this.dataSourceService.findInputValues(this.settings.inputParam);
    data.inputType = [];
    url = `/ApiInvoker/Invoke/${this.settings.dataSourceId}`;

    this.essentialsService.postData(url, data).subscribe((res: any) => {
      this.APIData = res ? res : [];

      if (Array.isArray(this.APIData)) {
        this.APIData.sort(
          this.dynamicSort(this.settings.orderType + this.settings.orderBy),
        );
        this.totalItems = this.APIData.length;
        this.disblayedData =
          this.APIData && this.APIData.length
            ? this.APIData.slice(0, this.settings.itemsPerPage)
            : [];
        this.showItems = this.settings.itemsPerPage;
      } else {
        console.log('data source result', this.APIData);
      }
    });
  }

  public getManualData() {
    if (this.settings.apiLink) {
      this.essentialsService.getData(this.settings.apiLink).subscribe((res: any) => {
        this.APIData = [];
        if (this.settings.responseKeys) {
          const keys = this.settings.responseKeys.split('=>');
          let obj = {};
          for (const k of keys) {
            obj = res;
            obj = obj[k] ? obj[k] : [];
          }
          this.APIData = obj ? obj : [];
        } else {
          this.APIData = res && res.length ? res : [];
        }
        this.APIData.sort(this.dynamicSort(this.settings.orderType + this.settings.orderBy));
        this.totalItems = this.APIData.length;
        this.disblayedData = this.APIData && this.APIData.length ? this.APIData.slice(0, this.settings.itemsPerPage) : [];
        this.showItems = this.settings.itemsPerPage;
      });
    }
  }

  public dynamicSort(property) {
    let sortOrder = 1;
    if (property[0] === '-') {
      sortOrder = -1;
      property = property.substr(1);
    }

    return (a, b) => {
      if (sortOrder === -1) {
        if (property) {
          return b[property] && b[property] !== null ? b[property].toString().localeCompare(a[property]) : -1;
        }
      } else {
        if (property) {
          return a[property] && a[property] !== null ? a[property].toString().localeCompare(b[property]) : -1;
        }
      }
    };
  }
  public pageChanged(event: PageChangedEvent): void {
    const startItem = (event.page - 1) * event.itemsPerPage;
    const endItem = event.page * event.itemsPerPage;
    this.disblayedData = this.APIData.slice(startItem, endItem);
  }

  public increaseShow() {
    this.showItems += this.settings.itemsPerPage;
    this.disblayedData = this.APIData.slice(0, this.showItems);
  }
  public decreaseShow() {
    if (this.showItems > this.settings.itemsPerPage) {
      this.showItems -= this.settings.itemsPerPage;
      this.disblayedData = this.APIData.slice(0, this.showItems);
    }

  }
}
